import { render, staticRenderFns } from "./SpoiledRoute.vue?vue&type=template&id=ea0c7d08&scoped=true&"
import script from "./SpoiledRoute.vue?vue&type=script&lang=js&"
export * from "./SpoiledRoute.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledRoute.vue?vue&type=style&index=0&id=ea0c7d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0c7d08",
  null
  
)

export default component.exports